import { ExpandableImage } from '@/components/expandable-image/component';
import { MobileContainer } from '@/components/workflow/mobile-container';
import { MobileHeader } from '@/components/workflow/mobile-header';
import { Flex, Grid, Text, TextInput } from '@mantine/core';
import { useBaleInboundContext } from '../hook';
import styles from '../styles.module.css';

export const BaleInboundDocketEditPage = () => {
	const { setPage, formData, handleManualCreateInput } = useBaleInboundContext();

	return (
		<MobileContainer
			header={<MobileHeader title="Load Details" onBack={() => setPage('RECEIVING')} />}
		>
			<Flex direction="column" gap="md" pb={100} p="md">
				<TextInput
					label="Docket ID"
					placeholder="Enter Docket ID"
					value={formData.docketId || ''}
					onChange={(e) => handleManualCreateInput('docketId', e.target.value)}
				/>
				<ExpandableImage src={formData.originalDocketPhoto || ''} id="docket-photo" />
				<div className={styles.docketAlertSuccess}>
					<Text style={{ fontSize: '14px' }}>
						Docket ID is required. Please enter a valid Docket ID.
					</Text>
				</div>
				<Grid>
					<Grid.Col span={6}>
						<TextInput
							label="Load Weight"
							value={formData.weight ? (formData.weight / 1000).toString() : ''}
							onChange={(e) => {
								const numValue = parseFloat(e.target.value || '0');
								handleManualCreateInput('weight', numValue * 1000);
							}}
							rightSection={
								<Text size="sm" pr={42}>
									Tonne
								</Text>
							}
							placeholder="Enter Load Weight"
						/>
					</Grid.Col>
					<Grid.Col span={6}>
						<TextInput
							value={formData.truckRegistration || ''}
							onChange={(e) => handleManualCreateInput('truckRegistration', e.target.value)}
							label="Truck Registration"
							placeholder="Enter Truck Registration"
						/>
					</Grid.Col>
				</Grid>
			</Flex>
		</MobileContainer>
	);
};
